var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-tn",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M124.02 0h496.06v496.06H124.02z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(-128) scale(1.0321)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e70013",
    d: "M0 0h744.09v496.06H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.81 247.81c0 69.096-56.014 125.109-125.11 125.109s-125.108-56.014-125.108-125.11S303.605 122.7 372.7 122.7s125.11 56.014 125.11 125.11z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.705 330.782c-45.799 0-82.969-37.17-82.969-82.969 0-45.8 37.17-82.97 82.969-82.97 11.45 0 24.483 2.634 33.336 9.136-60.681 2.284-76.029 53.75-76.029 74.492s9.813 67.001 76.028 73.833c-7.535 4.857-21.885 8.478-33.335 8.478z",
    fill: "#e70013"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e70013",
    d: "M445.8 282.71l-37.68-13.74-24.92 31.41 1.43-40.07-37.58-14 38.56-11.02 1.69-40.07 22.4 33.27 38.63-10.77-24.71 31.58z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTn);
export default __webpack_public_path__ + "static/media/tn.5b18c0080026920c3acfd38c1f7aebe7.svg";
export { ForwardRef as ReactComponent };